import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty, find, last } from 'lodash';
import moment from 'moment';
import { MessageCircle } from 'lucide-react';
import Button from './Button';

const PortfolioCommentIcon = ({ title }) => {
  const {
    chatGroup: { updateChatGroupAttribute },
  } = useDispatch();

  const [isActive, setIsActive] = useState(false);
  const [currentChatGroup, setCurrentChatGroup] = useState(null);

  const {
    chatGroup,
    user: {
      current: { id: userId },
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if (!userId || isEmpty(chatGroup.collection)) return;

    const chatGroupItem = find(chatGroup.collection, ['name', title]);
    setCurrentChatGroup(chatGroupItem);

    const lastComment = last(chatGroupItem?.chatGroupComments);
    if (!lastComment) return;

    const currentChatGroupMember = find(chatGroupItem.chatGroupMembers, [
      'userId',
      userId,
    ]);
    if (!currentChatGroupMember) return;

    const activeAt = moment(currentChatGroupMember?.activeAt);
    const createdAt = moment(lastComment?.createdAt);

    if (
      activeAt.isBefore(createdAt) ||
      currentChatGroupMember.activeAt === null
    ) {
      setIsActive(true);
    } else setIsActive(false);
  }, [chatGroup, userId]);

  const handleIconClick = () => {
    if (currentChatGroup) {
      updateChatGroupAttribute({
        isExpanded: true,
        selectedChatGroup: currentChatGroup,
        commentIsOpened: true,
      });
    }
  };

  return (
    <Button
      aria-label="Add Comment"
      className="absolute top-7 right-7 rounded-full p-4"
      disabled={isActive}
      onClick={handleIconClick}
    >
      <MessageCircle />
    </Button>
  );
};

export default PortfolioCommentIcon;
